module.exports = __webpack_public_path__ + "static/media/contract_address-01.a2bc4753.png";